// import { useEffect, useRef, useState } from "react";
// import { HiChevronDown, HiMenu } from "react-icons/hi";
// import { NavLink, useNavigate } from "react-router-dom";
// import logo from "../../../Assets/logo.png";

// const navItems = [
//   { name: "Home", path: "/" },
//   { name: "About", path: "/about" },
//   { name: "Products", path: "/products" },
//   { name: "Blog", path: "/blog" },
//   { name: "Contact", path: "/contact" },
// ];

// function Navbar() {
//   const [open, setOpen] = useState(false);
//   const menuRef = useRef(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setOpen(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <header
//       ref={menuRef}
//       className="w-full bg-[#1A3617] md:bg-[#232323] border-b border-gray-200"
//     >
//       {/* NAVBAR */}
//       <div className="flex items-center justify-between min-h-[50px] px-4 sm:px-6 md:px-10">
//         {/* LEFT NAV */}
//         <nav className="hidden xl:flex items-center gap-12 text-sm font-medium flex-1">
//           {navItems.map((item) =>
//             item.dropdown ? (
//               <button
//                 key={item.name}
//                 className="flex items-center gap-1 hover:text-headingText transition"
//               >
//                 {item.name}
//                 <HiChevronDown className="text-sm" />
//               </button>
//             ) : (
//               <NavLink
//                 key={item.name}
//                 to={item.path}
//                 className={({ isActive }) =>
//                   `transition text-white hover:text-[#92AD36] ${
//                     isActive ? "text-[#92AD36] font-semibold" : "text-white"
//                   }`
//                 }
//               >
//                 {item.name}
//               </NavLink>
//             ),
//           )}
//         </nav>

//         {/* RIGHT SIDE */}
//         <div className="flex  items-center justify-end flex-1">
//           {/* DESKTOP CTA */}
//           <div className="hidden xl:flex">
//             <button className="px-4 py-3 bg-[#92AD36] text-black hover:bg-white hover:text-[#92AD36] border border-[#92AD36] duration-300 rounded-xl text-xs font-semibold">
//               Enquiry Now
//             </button>
//           </div>

//           {/* MOBILE MENU BUTTON */}
//           <div className="flex justify-between items-center w-full p-4 xl:hidden">
//             <img className="h-10 w-10" src={logo} alt="logo" />

//             <button
//               className="text-white text-2xl"
//               onClick={() => setOpen(!open)}
//             >
//               <HiMenu />
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* MOBILE MENU (UNCHANGED STRUCTURE) */}
//       <div
//         className={`xl:hidden border-t bg-[#232323] overflow-hidden transition-all duration-300 ease-in-out ${
//           open
//             ? "max-h-96 opacity-100 translate-y-0"
//             : "max-h-0 opacity-0 -translate-y-2"
//         }`}
//       >
//         <div
//           className={`xl:hidden border-t bg-[#232323] overflow-hidden transition-all duration-300 ease-in-out ${
//             open
//               ? "max-h-96 opacity-100 translate-y-0"
//               : "max-h-0 opacity-0 -translate-y-2"
//           }`}
//         >
//           <div className="grid grid-cols-2 px-4 py-4 gap-3 text-descriptionText">
//             {navItems.map((item) => (
//               <NavLink
//                 key={item.name}
//                 to={item.path}
//                 onClick={() => setOpen(false)}
//                 className={({ isActive }) =>
//                   `text-left text-white  py-2 ${
//                     isActive ? "text-[#92AD36] font-semibold" : ""
//                   }`
//                 }
//               >
//                 {item.name}
//               </NavLink>
//             ))}

//             <NavLink
//               to="/inquiry"
//               className="col-span-2 mt-2 bg-[#92AD36] text-[#000000] text-center py-3 rounded-lg"
//               onClick={() => setOpen(false)}
//             >
//               Enquiry Now
//             </NavLink>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// }

// export default Navbar;

import { useEffect, useRef, useState } from "react";
import { HiChevronDown, HiMenu, HiX } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import logo from "../../../Assets/logo.png";
import InquiryModal from "../../../components/common/InquiryModal";

const navItems = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Products", path: "/products" },
  { name: "Blog", path: "/blog" },
  { name: "Gallery", path: "/gallery" },
  { name: "Corporate", path: "/corporate" },
  { name: "Carrier", path: "/carrier" },
  { name: "Contact", path: "/contact" },
];

function Navbar() {
  const [open, setOpen] = useState(false);
  const [showInquiry, setShowInquiry] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  //  Lock body scroll when mobile menu is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <header
        ref={menuRef}
        className="w-full bg-[#1A3617] md:bg-[#232323] border-b border-gray-200 relative z-50"
      >
        {/* NAVBAR */}
        <div className="flex items-center justify-between min-h-[50px] px-4 sm:px-6 md:px-10">
          {/* LEFT NAV — Desktop */}
          <nav className="hidden xl:flex items-center gap-12 text-sm font-medium flex-1">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                // ✅ Fix: use className function for active state
                className={({ isActive }) =>
                  `transition-colors duration-200 hover:text-[#92AD36] ${
                    isActive
                      ? "text-[#92AD36] font-semibold border-b-2 border-[#92AD36] pb-0.5"
                      : "text-white"
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
          </nav>

          {/* RIGHT SIDE */}
          <div className="flex items-center justify-end flex-1">
            {/* DESKTOP CTA */}
            <div className="hidden xl:flex">
              <button
                onClick={() => setShowInquiry(true)}
                className="px-4 py-3 bg-[#92AD36] text-black hover:bg-white hover:text-[#92AD36] border border-[#92AD36] duration-300 rounded-xl text-xs font-semibold"
              >
                Enquiry Now
              </button>
            </div>

            {/* MOBILE TOP BAR */}
            <div className="flex justify-between items-center w-full px-2 py-3 xl:hidden">
              <img className="h-10 w-10" src={logo} alt="logo" />
              {/* ✅ Toggle icon between menu and X */}
              <button
                className="text-white text-2xl p-1"
                onClick={() => setOpen(!open)}
                aria-label="Toggle menu"
              >
                {open ? <HiX /> : <HiMenu />}
              </button>
            </div>
          </div>
        </div>

        {/*  MOBILE MENU — fixed overlay, does NOT push content */}
        <div
          className={`xl:hidden fixed top-[57px] left-0 right-0 bg-[#232323] z-40 transition-all duration-300 ease-in-out shadow-xl ${
            open
              ? "opacity-100 translate-y-0 pointer-events-auto"
              : "opacity-0 -translate-y-3 pointer-events-none"
          }`}
        >
          <div className="grid grid-cols-2 px-4 py-5 gap-3">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-left py-2 px-3 rounded-lg text-sm transition-colors duration-200 ${
                    isActive
                      ? "text-[#92AD36] font-semibold bg-white/5"
                      : "text-white hover:text-[#92AD36]"
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}

            <button
              onClick={() => {
                setShowInquiry(true);
                setOpen(false);
              }}
              className="col-span-2 mt-2 bg-[#92AD36] text-black text-center py-3 rounded-lg font-semibold hover:bg-[#7a9230] transition"
            >
              Enquiry Now
            </button>
          </div>
        </div>
      </header>

      {/*  Backdrop for mobile menu */}
      {open && (
        <div
          className="fixed inset-0 bg-black/30 z-30 xl:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Inquiry Modal */}
      {showInquiry && <InquiryModal onClose={() => setShowInquiry(false)} />}
    </>
  );
}

export default Navbar;
